/**
 * Strip known audio suffixes from a Chronicle device filename for analytics.
 *
 * Canonical helper for HAR-1777 PR2 (#21808) — sibling PR1 imports this path;
 * do not reintroduce a second copy or a `string → string` overload.
 *
 * Datadog / Snowplow joins on the bare stem (`sess_<id>`, `encrypted_<ts>`, …).
 * Call at every analytics emit of `device_file_name` (Snowplow + Datadog).
 * Do NOT use for task_id, registry writes, engine identity, or BLE state —
 * those keep the raw FW/engine string. Never invent or append a suffix here.
 *
 * Empty / missing / suffix-only input → `undefined` (omits an optional prop)
 * rather than emitting `''`. Required-prop call sites must fall back with
 * `stripDeviceFileNameForAnalytics(x) ?? x`.
 */
// Order-independent: `endsWith` is anchored, so at most one suffix can match.
const KNOWN_AUDIO_SUFFIXES = [
  '.mp3.enc',
  '.mp3',
  '.wav',
  '.m4a',
  '.opus',
  '.aac',
] as const;

export function stripDeviceFileNameForAnalytics(
  deviceFileName: string | undefined | null
): string | undefined {
  if (deviceFileName == null || deviceFileName === '') return undefined;
  const lower = deviceFileName.toLowerCase();
  for (const suffix of KNOWN_AUDIO_SUFFIXES) {
    if (lower.endsWith(suffix)) {
      const stripped = deviceFileName.slice(0, -suffix.length);
      return stripped === '' ? undefined : stripped;
    }
  }
  return deviceFileName;
}
